import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../../layouts/Header";
import Sidebar from "../../../layouts/Sidebar";
import DataTable from "datatables.net-react";
import DT from "datatables.net-dt";
import "datatables.net-responsive-dt";

DataTable.use(DT);

const UserMaster = () => {
  const [menu, setMenu] = useState(false);
  const [data, setData] = useState([
    [
      "1",
      "Akshay",
      "Owner",
      "Sagacity Solutions India, Nagpur",
      "Start date",
      "Action",
    ],
    [
      "2",
      "Dasharath S Wandhare",
      "Entrepreneur",
      "Tech Ojas LLP, JP Nagar, Somalwada, Nagpur",
      "Start date",
      "Action",
    ],
  ]);

  const toggleMobileMenu = () => {
    setMenu(!menu);
  };

  let navigate = useNavigate();
  const addNewUser = () => {
    let path = `/add-user`;
    navigate(path, { replace: false });
  };

  return (
    <div>
      <div className={`main-wrapper ${menu ? "slide-nav" : ""}`}>
        <Header onMenuClick={(value) => toggleMobileMenu()} />
        <Sidebar />
        <div className="page-wrapper">
          <div className="p-8">
            <div className="">
              {/* <h1 className="text-2xl text-black">This Is User Master</h1> */}
              <div className="card flex-grow">
                <div className="p-3 border-b-2">
                  <div className="justify-between items-center">
                    <div className="flex flex-wrap">
                      <div className="col-xl-7 lg:w-3/5 p-2">
                        <h1 className="text-2xl text-black">User Master</h1>
                        <span className="text-red-500">Admin & User Side</span>
                      </div>
                      <div className="col-xl-5 lg:w-2/5 p-2">
                        <button
                          className="bg-gray-100 hover:bg-green-300 text-green-700 font-bold border-solid border-2 hover:border-green-400 border-gray-200 py-2 px-4 rounded inline-flex items-center float-right"
                          onClick={addNewUser}
                        >
                          <svg
                            className="fill-current w-4 h-4 mr-2"
                            xmlns="http://www.w3.org/2000/svg"
                            viewBox="0 0 25 25"
                          >
                            <path
                              d="M12,1C5.9,1,1,5.9,1,12s4.9,11,11,11s11-4.9,11-11S18.1,1,12,1z M17,14h-3v3c0,1.1-0.9,2-2,2s-2-0.9-2-2v-3H7   c-1.1,0-2-0.9-2-2c0-1.1,0.9-2,2-2h3V7c0-1.1,0.9-2,2-2s2,0.9,2,2v3h3c1.1,0,2,0.9,2,2C19,13.1,18.1,14,17,14z"
                              id="add"
                            />
                          </svg>
                          <span>Create User</span>
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
                <div className="relative p-6">
                  <DataTable
                    data={data}
                    className="display"
                    options={{
                      responsive: true,
                      paging: true,
                      searching: true,
                      ordering: true,
                      sorting: true,
                      pageLength: 5,
                      lengthMenu: [
                        [5, 10, 20, -1],
                        [5, 10, 20, "All"],
                      ],
                      info: true,
                      language: {
                        searchPlaceholder: "Search users...",
                        lengthMenu: "Show _MENU_ entries",
                      },
                    }}
                  >
                    <thead>
                      <tr>
                        <th>id</th>
                        <th>Name</th>
                        <th>Role</th>
                        <th>Office Address</th>
                        <th>Start Date</th>
                        <th>Action</th>
                      </tr>
                    </thead>
                  </DataTable>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
export default UserMaster;
